import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { EmailPreviewDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface EmailPreviewModalProps {
  show: boolean;
  onHide: () => void;
  preview: EmailPreviewDto;
}

export const EmailPreviewModal: React.FC<EmailPreviewModalProps> = props => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.preview.subject}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className="email-preview-content"
          dangerouslySetInnerHTML={{ __html: props.preview.htmlContent }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Zamknij
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
